<div mat-dialog-title class="title">
  <div class="header">
    <h3>{{"logoManagement.sectionTitle" | translate }}</h3>
    <evc-svg-icon icon="xmark" size="md" class="close-icon" [mat-dialog-close]></evc-svg-icon>
  </div>
</div>
<mat-dialog-content class="content">

<div class="drop-box" (click)="useApplicationFileManager ? showFileManager() : fileSelector.click()" (drop)="onDrop($event)" (dragover)="onDragOver($event)"  [class.hovering]="isHovering">
  @if (!imageUrl){
    <div class="image-icon">
        <svg>
            <use xlink:href="assets/icons/uploadImages/image.svg#image" href="assets/icons/uploadImages/image.svg#image"/>
        </svg>
    </div>
    <div class="message">
      {{ 'logoManagement.importLogoMessage' | translate }}
    </div>
    <div class="sub-message">
      {{ 'logoManagement.orDragAndDrop' | translate }}
    </div>
  }

  @else {
    <img [src]="imageUrl" alt="Logo">
  }
</div>

</mat-dialog-content>

<mat-dialog-actions class="actions">
  @if(imageUrl){
    <evc-nav-button [type]="'tertiary'" (click)="removeLogo()">{{ 'logoManagement.removeLogo' | translate }}</evc-nav-button>
  }
  <evc-nav-button [mat-dialog-close] [type]="'primary'" (click)="import()" [disabled]="!imageUrl">{{ (isEdit ? "common.update" : "logoManagement.importLogo") | translate }}</evc-nav-button>
</mat-dialog-actions>

<input type="file" accept="image/png, image/bmp, .png, .bmp" hidden (change)="onFilePick($event)" #fileSelector />
